/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { generateRandomId } from "utils/modifier_group_helper"
import { UploadType } from "types/delv-platform-api/bulkUploadTask"
import { EventAction, EventCategory } from "./tracking"

// caveat: adding new tab key need to consider changing defaultShownMenuEditorTabs const below
export const menuEditorTabKeys = {
  menuOverview: "menuOverview",
  items: "items",
  modifierGroups: "modifierGroups",
  bulkUploadInventory: "bulkUploadInventory",
  bulkUploadMenu: "bulkUploadMenu",
} as const

export type MenuEditorTabKey = keyof typeof menuEditorTabKeys

export const menuTabEventCategories: {
  [key: string]: EventCategory
} = {
  [menuEditorTabKeys.menuOverview]: EventCategory.menuOverviewTab,
  [menuEditorTabKeys.items]: EventCategory.menuItemsTab,
  [menuEditorTabKeys.modifierGroups]: EventCategory.menuModifierGroupsTab,
  [menuEditorTabKeys.bulkUploadInventory]: EventCategory.menuBulkUploadTab,
  [menuEditorTabKeys.bulkUploadMenu]: EventCategory.menuBulkUploadTab,
}

export const menuTabEventActions: {
  [key: string]: EventAction
} = {
  [menuEditorTabKeys.menuOverview]: EventAction.clickTabOverview,
  [menuEditorTabKeys.items]: EventAction.clickTabItems,
  [menuEditorTabKeys.modifierGroups]: EventAction.clickTabModifierGroups,
  [menuEditorTabKeys.bulkUploadInventory]: EventAction.clickTabBulkUpdates,
  [menuEditorTabKeys.bulkUploadMenu]: EventAction.clickTabBulkUpdates,
}

export const DEFAULT_PAGE_SIZE_BRAND_NAME = 50
export const DEFAULT_PAGE_SIZE_ATTRIBUTE_OPTION = 50

export enum TranslationType {
  item = "item",
  category = "category",
  modifierGroup = "modifier group",
  modifier = "modifier",
}

export enum TextType {
  name = "name",
  description = "description",
}

export enum ColumnKey {
  price = "price",
  stockManagement = "stockManagement",
}

export const initialModifiers = [
  {
    modifierID: generateRandomId(5),
    modifierName: "",
    priceDisplay: "0",
    isNeedExtraCost: false,
    availableStatus: 1,
    sortOrder: 0,
    quantity: 1,
    priceInMin: 0,
  },
]

export const emptyModifierGroup = {
  modifierGroupID: "",
  modifierGroupName: "",
  modifiers: initialModifiers,
  selectionRangeMin: 1,
  selectionRangeMax: 1,
  relatedItemIDs: [],
}

export const enableBulkUploadProcessingBannerByUploadTypeDefaultValue: Record<
  UploadType,
  boolean
> = {
  [UploadType.UpdateItemStock]: false,
  [UploadType.UpdateMenuSingle]: false,
  [UploadType.UpdateMenuGroup]: false,
  [UploadType.EcommerceProduct]: false,
}
